import { memo, useEffect, useRef, useState } from 'react';
import { Box, CircularProgress } from '@mui/material';
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';

const frasesLoading = [
  'Buscando documentos dos títulos',
  'Analisando conteúdo dos documentos',
  'Validando informações dos títulos',
  'Preparando para incluir na cessão',
  'Finalizando processo'
];

function LoadingBoxUpload({ passos = frasesLoading, passoMs = 650, iniciar = true, onFim }) {
  const [currentStep, setCurrentStep] = useState(0);
  const timerRef = useRef(null);
  const hasFinishedRef = useRef(false);
  const finished = currentStep >= passos.length;
  const visibleCount = finished ? passos.length : currentStep + 1;

  useEffect(() => {
    if (!iniciar) {
      clearInterval(timerRef.current);
      timerRef.current = null;
      setCurrentStep(0);
      hasFinishedRef.current = false;
      return;
    }

    if (timerRef.current) return;

    timerRef.current = setInterval(() => {
      setCurrentStep(prev => prev + 1);
    }, passoMs);

    return () => {
      clearInterval(timerRef.current);
      timerRef.current = null;
    };
  }, [iniciar, passoMs]);

  useEffect(() => {
    if (finished && !hasFinishedRef.current) {
      hasFinishedRef.current = true;
      clearInterval(timerRef.current);
      timerRef.current = null;
      onFim?.();
    }
  }, [finished, onFim]);

  return (
    <Box className="simulacao-content">
      {passos.slice(0, visibleCount).map((label, idx) => {
        const concluido = idx < currentStep;
        const ultimoElemento = idx === passos.length - 1;

        return (
          <Box className={`${ultimoElemento ? 'ultimo-elemento' : ''} simulacao-title`} key={label}>
            {concluido && <CheckBoxOutlinedIcon className="icone-check" fontSize="small" />}
            {!concluido && <CircularProgress size="18px" />}
            <Box className="simulacao-label">{label}</Box>
          </Box>
        );
      })}
    </Box>
  );
}

export default memo(LoadingBoxUpload);
